import abstractModel from '../../../core/MercatelyModel';
import { MERCATELY_API_V2 } from '../../../constants/AppConstants';

const resource = `${MERCATELY_API_V2}/customers`;

const model = abstractModel(resource);

model.byPhone = async (params) => model.get(params, { path: `${resource}/by_phone` });

export default model;
